import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { NotificationStatus } from '@repo/types/enums/notificationStatus';
import { useInfiniteQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { NotificationKey } from './keys';
import { NotificationService } from './notificationService';

export function useGetNotificationsInfinite(status: NotificationStatus = NotificationStatus.All) {
  const getNotificationsInfiniteQuery = useInfiniteQuery({
    queryKey: [NotificationKey.NOTIFICATIONS_INFINITE, status],
    queryFn: ({ pageParam }) => NotificationService.getNotifications({ ...pageParam, status: status }).then((response) => response.data),
    initialPageParam: {
      page: 0,
      pageSize: 20,
      status,
    },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
  });

  const errorMessage = useErrorMessage(getNotificationsInfiniteQuery.error, baseErrorMessages);

  return { ...getNotificationsInfiniteQuery, errorMessage };
}
